import { render, staticRenderFns } from "./SelectGroupLevels.vue?vue&type=template&id=310cf11a&scoped=true&"
import script from "./SelectGroupLevels.vue?vue&type=script&lang=js&"
export * from "./SelectGroupLevels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310cf11a",
  null
  
)

export default component.exports